import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { labQKeys } from "@hooks/queries/lab/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  lab: FormData;
  labGroupId: string;
  patientId: string;
}

export const useUpdateLabGroup = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ lab, labGroupId }: MutationProps) => {
      return api.patch(`lab/group/${labGroupId}`, lab, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (_, variables) => {
      showSuccessNotification({
        title: "success",
        message: "update-lab-group-success",
      });
      queryClient.invalidateQueries({
        queryKey: labQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Update Lab Group]", res);
      handleErrors(res, "mutation");
    },
  });
};
